import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const optionShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
});

const propTypes = {
    ariaLabel: PropTypes.string,
    currentValue: PropTypes.string.isRequired,
    groupName: PropTypes.string.isRequired,
    /** (e: { target: { value: string } }) => void */
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(optionShape).isRequired
};

const defaultProps = {
    ariaLabel: 'Select delivery method'
};

/**
 * Segmented delivery control (@pattern-library/buttons button list markup).
 * Submits exactly one POST field via hidden input `{groupName}=sms|voice|password`.
 */
function DeliveryMethodButtonList(props) {
    const { ariaLabel, currentValue, groupName, onChange, options } = props;

    const handleActivate = optionValue => {
        if (optionValue !== currentValue) {
            onChange({ target: { value: optionValue } });
        }
    };

    return (
        <div className="text--center">
            {/* Single field so model binding stays stable (deliveryMethod ↔ DeliveryMethod) */}
            <input type="hidden" name={groupName} value={currentValue} />

            <ul className="asc-btn-list" role="radiogroup" aria-label={ariaLabel}>
                {options.map(option => (
                    <li key={option.id}>
                        <button
                            type="button"
                            className={classNames('asc-btn-list-option', {
                                'is-active': currentValue === option.value
                            })}
                            aria-pressed={currentValue === option.value}
                            onClick={() => handleActivate(option.value)}
                        >
                            {option.label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

DeliveryMethodButtonList.propTypes = propTypes;
DeliveryMethodButtonList.defaultProps = defaultProps;
export default DeliveryMethodButtonList;
